import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ActiveInactiveVisaGateway,
  createVisaGateway,
  deleteVisaGateway,
  getAllActiveVisaGateway,
  getAllVisaGateway,
  getVisaGatewayByID,
  updateVisaGateway,
  VisaGatewayImageUpload,
} from "./services/visagateway.services";
import { IVisaGateway, IVisaGatewayInitialState } from "./visagatewayModel";

const initialState: IVisaGatewayInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  VisaGatewayList: [],
  VisaGatewayID: null,
  VisaGatewayDetail: {
    VisaType: "",
    Image: "",
    CountryID: null,
    IsActive: 1,
  },
};

const visagatewaySlice = createSlice({
  name: "visagateway",
  initialState,
  reducers: {
    clearVisaGatewayDetails: (state) => {
      state.VisaGatewayDetail = initialState.VisaGatewayDetail;
    },
    setVisaGatewayID: (state, action) => {
      state.VisaGatewayID = action.payload;
    },
    clearVisaGatewayID: (state) => {
      state.VisaGatewayID = initialState.VisaGatewayID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllVisaGateway.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllVisaGateway.fulfilled,
      (state, action: PayloadAction<IVisaGateway[]>) => {
        state.loading = false;
        state.VisaGatewayList = action.payload || [];
      }
    );
    builder.addCase(getAllVisaGateway.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaGatewayList = [];
    });
    builder.addCase(createVisaGateway.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createVisaGateway.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createVisaGateway.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateVisaGateway.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateVisaGateway.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateVisaGateway.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteVisaGateway.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteVisaGateway.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteVisaGateway.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getVisaGatewayByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getVisaGatewayByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.VisaGatewayDetail = action.payload;
    });
    builder.addCase(getVisaGatewayByID.rejected, (state, action) => {
      state.formLoading = false;
      state.VisaGatewayDetail = initialState.VisaGatewayDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveVisaGateway.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveVisaGateway.fulfilled,
      (state, action: PayloadAction<IVisaGateway[]>) => {
        state.loading = false;
        state.VisaGatewayList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveVisaGateway.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.VisaGatewayList = [];
    });
    builder.addCase(ActiveInactiveVisaGateway.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveVisaGateway.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveVisaGateway.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(VisaGatewayImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(VisaGatewayImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(VisaGatewayImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearVisaGatewayDetails, clearVisaGatewayID, setVisaGatewayID } =
  visagatewaySlice.actions;
export default visagatewaySlice.reducer;
